import { ImagesArticles } from "@/Components/Index";

type Props = {
  srcx: string;
  altx: string;
  classNames: string;
  srcDefault: string;
};

export const ImageCarousel = ({
  srcx,
  altx,
  classNames,
  srcDefault,
}: Props): JSX.Element => {
  return (
    <div className="item">
      <ImagesArticles
        srcx={srcx}
        altx={altx}
        classNames={classNames}
        srcDefault={srcDefault}
      />
    </div>
  );
};
